<script>
	import { uiText } from "../lib/uiText.js";
	import { createEventDispatcher, onMount } from "svelte";
	import Sortable from "sortablejs/modular/sortable.complete.esm.js";

	const dispatch = createEventDispatcher();
	export let lang = "en";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));
	// export let pastAnswers = [];
	export let riddle;
	// console.log(riddle);
	// let progbar = riddle.progbar;
	let type = riddle.type || "single";
	let answers = riddle.answers;
	let isBonus = false;
	let input = "";
	let order = [];
	let wrongAnswers = [];

	// const inActive = [];
	// const inPast = [];

	onMount(() => {
		let el = document.getElementById("reorder");

		function logSort() {
			order = sortable.toArray();
			// console.log(order);
			if (type == "dnd-reorder") {
				input = order.join("-");
			}
		}

		let sortable = Sortable.create(el, {
			animation: 150,
			swap: riddle.order_type == "grid" ? true : false,
			filter: ".fixed-piece", // Prevents picking up the fixed pieces
			onMove: function (evt) {
				// Prevents other pieces from pushing or swapping with the fixed pieces
				return !evt.related.classList.contains("fixed-piece");
			},
			onEnd: function (/**Event*/ evt) {
				logSort();
			},
		});
		logSort();
	});

	// console.log(pastAnswers);
	// console.log(Object.keys(pastAnswers));
	// console.log(Object.keys(answers));
	// let pastAnswerKeys = Object.keys(pastAnswers);
	// let answerKeys = Object.values(answers);
	// // console.log(answerKeys);
	// for (let i = 0; i < answers.length; i++) {
	//     let singAnw;
	//     if (typeof answerKeys[i] === 'object') {
	//         singAnw = Object.values(answerKeys[i])[0];
	//         // console.log(Object.values(answerKeys[i])[0]);
	//     } else {
	//         singAnw = answerKeys[i];
	//         // console.log(answerKeys[i]);
	//     }
	//     inPast[i] = pastAnswerKeys.some((el) => singAnw.toLowerCase().includes(el));
	// }
	// console.log(inPast);

	// export let prog
	//$: input,
	//console.log('Single: ' + input.toLowerCase().includes(answers[0])), //сингъл
	//console.log('Multiple: ' + answers.some((el) => input.toLowerCase().includes(el))); //мултипъл

	// console.log(pastAnswers);
	//
	function checkAnswer() {
		if (input == "" || input.replace(/\s/g, "") == "") {
			console.warn("don't try empty answers, man!");
			return;
		}
		if (answers.some((el) => input.toLowerCase().includes(el))) {
			dispatch("message", {
				msg_content: ui.game.riddle.single_message,
				msg_type: "info",
				msg_action: ui.game.riddle.single_action,
			});
			if (riddle.isBonus) {
				isBonus = true;
			} else {
				isBonus = false;
			}
			dispatch("solve", {
				address: riddle.address,
				wrongAnswers: wrongAnswers,
				isBonus: isBonus,
			});
		} else {
			dispatch("message", {
				msg_content: ui.game.riddle.wrong_message,
				msg_type: "error",
				msg_action: ui.game.riddle.wrong_action,
			});
			wrongAnswers.push(input);
		}
	}

	const handleEnter = (e) => {
		if (e.key === "Enter" || e.keyCode === 13) {
			checkAnswer();
		}
	};
</script>

<ul
	id="reorder"
	class=" place-self-center"
	style={riddle.order_type == "grid"
		? "display:grid; grid-template-rows: repeat(" +
			riddle.order_size.rows +
			", max-content); grid-template-columns:repeat(" +
			riddle.order_size.cols +
			", max-content);"
		: riddle.order_type == "horizontal"
			? "display:flex;  flex-direction:row"
			: "display:flex; flex-direction:column"}
>
	{#each riddle.order_list as item, i}
		<li
			data-id={riddle.order_id_list ? riddle.order_id_list[i] || i : i}
			class={riddle.fixed_indices && riddle.fixed_indices.includes(i)
				? "fixed-piece"
				: ""}
		>
			{@html item}
		</li>
	{/each}
</ul>

<div class="input-row">
	{#if type !== "dnd-reorder"}
		<input
			class="grow"
			type="text"
			name="field"
			id="field"
			placeholder="_"
			bind:value={input}
			on:keyup={handleEnter}
		/>
	{/if}

	<button id="trigger" on:click={checkAnswer}
		>{type !== "dnd-reorder"
			? ui.game.aside.button
			: ui.game.aside.button_check}</button
	>
</div>

<style>
	.input-row {
		display: grid;
		grid-template-columns: 1fr max-content;
	}
	@media screen and (max-width: 480px) {
		.input-row {
			grid-template-columns: auto;
		}
	}
</style>
